module.exports = __webpack_public_path__ + "static/media/1027783.87413087.jpg";